import { BaseError } from './base';

export class InvalidStorageValue extends BaseError {
  constructor(key: string, value: unknown) {
    super({
      cause: null,
      code: 'invalid_storage_value',
      docsUrl: null,
      name: 'InvalidStorageValue',
      shortMessage: `Tried to store state with a forbidden value. Key: ${key}, Value: ${value}`,
    });
  }
}
